"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleParseWarningType = void 0;
exports.parseStyleFile = parseStyleFile;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var StyleParseWarningType;
(function (StyleParseWarningType) {
    StyleParseWarningType["UnrecognizedLine"] = "allegro-style-unrecognized-line";
    StyleParseWarningType["UnterminatedBlock"] = "allegro-style-unterminated-block";
})(StyleParseWarningType || (exports.StyleParseWarningType = StyleParseWarningType = {}));
const HEADER_RE = /^(Style\d+)\s*\{\s*$/;
const KV_RE = /^([a-zA-Z][a-zA-Z0-9_-]*)\s*:\s*(.*?)\s*$/;
const NUMERIC_RE = /^-?\d+(\.\d+)?$/;
function parseStyleFile(content) {
    const styles = new Map();
    const warnings = [];
    let current = null;
    const lines = content.split('\n');
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.length === 0 || line.startsWith('#') || line.startsWith('//')) {
            continue;
        }
        if (current === null) {
            const headerMatch = HEADER_RE.exec(line);
            if (headerMatch !== null) {
                current = makeEmptyStyle(headerMatch[1]);
                continue;
            }
            continue;
        }
        if (line === '}') {
            styles.set(current.name, current);
            current = null;
            continue;
        }
        const kv = KV_RE.exec(line);
        if (kv === null) {
            warnings.push({
                type: StyleParseWarningType.UnrecognizedLine,
                message: `line ${i + 1}: unrecognized line inside ${current.name}: ${JSON.stringify(line)}`,
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            });
            continue;
        }
        applyKeyValue(current, kv[1], kv[2]);
    }
    if (current !== null) {
        warnings.push({
            type: StyleParseWarningType.UnterminatedBlock,
            message: `unterminated style block ${current.name} (missing closing brace)`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
        });
    }
    return { styles, warnings };
}
function makeEmptyStyle(name) {
    return {
        name,
        lineWidth: null,
        lineColor: null,
        lineStyle: null,
        lineCapStyle: null,
        lineJoinStyle: null,
        fillColor: null,
        fillStyle: null,
        altFillColor: null,
        headerFillColor: null,
        fontName: null,
        fontSize: null,
        italic: null,
        bold: null,
        underline: null,
        fontColor: null,
        textMargin: null,
        textWordwrap: null,
        itemOpacity: null,
        instPropFontSize: null,
        pinPropFontSize: null,
        customImageMinimumLineWidth: null,
        extras: {},
    };
}
function applyKeyValue(style, key, value) {
    switch (key) {
        case 'line-width':
            style.lineWidth = parseNumber(value);
            return;
        case 'line-color':
            style.lineColor = value;
            return;
        case 'line-style':
            style.lineStyle = value;
            return;
        case 'line-cap-style':
            style.lineCapStyle = value;
            return;
        case 'line-join-style':
            style.lineJoinStyle = value;
            return;
        case 'fill-color':
            style.fillColor = value;
            return;
        case 'fill-style':
            style.fillStyle = value;
            return;
        case 'alt-fill-color':
            style.altFillColor = value;
            return;
        case 'header-fill-color':
            style.headerFillColor = value;
            return;
        case 'font-name':
            style.fontName = value;
            return;
        case 'font-size':
            style.fontSize = parseNumber(value);
            return;
        case 'italic':
            style.italic = parseBool(value);
            return;
        case 'bold':
            style.bold = parseBool(value);
            return;
        case 'underline':
            style.underline = parseBool(value);
            return;
        case 'font-color':
            style.fontColor = value;
            return;
        case 'text-margin':
            style.textMargin = parseNumber(value);
            return;
        case 'text-wordwrap':
            style.textWordwrap = parseBool(value);
            return;
        case 'item-opacity':
            style.itemOpacity = parseNumber(value);
            return;
        case 'inst-prop-font-size':
            style.instPropFontSize = parseNumber(value);
            return;
        case 'pin-prop-font-size':
            style.pinPropFontSize = parseNumber(value);
            return;
        case 'custom-image-minimum-line-width':
            style.customImageMinimumLineWidth = parseNumber(value);
            return;
        default:
            style.extras[key] = value;
            return;
    }
}
function parseNumber(value) {
    if (!NUMERIC_RE.test(value)) {
        return null;
    }
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : null;
}
function parseBool(value) {
    const v = value.toLowerCase();
    if (v === 'true') {
        return true;
    }
    if (v === 'false') {
        return false;
    }
    return null;
}
//# sourceMappingURL=styleParser.js.map